
import Api from '@/Plugins/api'

// expressed in seconds
const SYNC_ORDERS_INTERVAL = 60
const SYNC_ORDERS_RETRY = 5

const state = () => ({
  /**
   * @type Boolean
   */
  synchronizing: false,

  /**
   * @type Boolean
   */
  shouldSynchronize: false,

  /**
   * @type Boolean
   */
  skipSynchronize: false,

  /**
   * @type Number
   */
  _syncOrdersTimer: null,
})

const getters = {}

const mutations = {
  synchronizing (state, v = true) {
    state.synchronizing = v
  },
  shouldSynchronize (state, v) {
    state.shouldSynchronize = v
  },
  skip (state, v = true) {
    state.skipSynchronize = v
  },
  _syncOrdersTimer (state, v) {
    state._syncOrdersTimer = v
  },
}

const actions = {
  orders ({ state, commit, dispatch, rootState }) {
    // Synchronize open orders again after X time
    // (but not every X time, note the subtle difference)
    clearTimeout(state._syncOrdersTimer)

    if (state.synchronizing || state.skipSynchronize || rootState.user.screenLocked) {
      commit('_syncOrdersTimer', setTimeout(() => dispatch('orders'), SYNC_ORDERS_RETRY * 1000))

      return Promise.resolve()
    }

    commit('_syncOrdersTimer', setTimeout(() => dispatch('orders'), SYNC_ORDERS_INTERVAL * 1000))
    commit('synchronizing')

    return Api('syncOrders')
      .then(r => {
        if (state.skipSynchronize) {
          return
        }
        dispatch('orders/sync', r.data?.open, { root: true })
      })
      .catch(e => console.error(e)) // no need to bother the user by dispatching an xError
      .finally(() => commit('synchronizing', false))
  },
  stop ({ state, commit }) {
    clearTimeout(state._syncOrdersTimer)
    commit('synchronizing', false)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
